import useQuery from 'hooks/useQuery';
import { useMemo } from 'react';

import DateTime from 'utils/datetime';
import { CollectionStatsApiResponse } from '../types';

const useCashActivity = (country: string) => {
  const options = useMemo(
    () => ({
      params: {
        'country.equals': country,
        'paymentType.equals': 'cash',
        'lastModifiedDate.greaterThan': DateTime.startOfDay(
          DateTime.now(),
        ).format(),
      },
    }),
    [country],
  );

  return useQuery<CollectionStatsApiResponse>(
    'collection/cash-activities',
    options,
    !!country,
  );
};

export default useCashActivity;
